class Bridge {
  static postMessage(name, data = {}) {
    // iOS
    window.webkit?.messageHandlers?.nativeApp?.postMessage({name, ...data})

    // Android
    window.nativeApp?.postMessage(JSON.stringify({name, ...data}))
  }

  static get isTurboNativeApp() {
    return navigator.userAgent.indexOf("Turbo Native") !== -1
  }

  static shareMobileNews() {
    // Android
    document.getElementById('shareDropdownToggle')?.parentElement?.classList.toggle('dropdown-open');

    // iOS
    document.getElementById('shareMobileNews')?.querySelector('a')?.click();
  }

  static toggleMobileAccessibility() {
    const accessibilityDialog = document.querySelector('[data-font-size-target="dialog"]');
    if (!accessibilityDialog) return;

    if (accessibilityDialog.open) {
      accessibilityDialog.close();
    } else {
      accessibilityDialog.showModal();
    }
  }

  static async updatePushNotificationDevice(deviceUid) {
    const container = document.getElementById('updatePushNotificationDevice');
    if (!container) return;

    try {
      const response = await fetch('/api/v1/devices.json', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Device-Uid': deviceUid,
        }
      });

      const data = await response.json();
      const device = data.device;
      if (!device) return;

      const checkbox = document.getElementById('pushToggle');
      if (checkbox) {
        checkbox.removeAttribute('disabled');
        checkbox.checked = device.push_enabled ?? false;
      }

      const notificationSoundSection = document.getElementById('notificationSoundPreference');
      if (notificationSoundSection) {
        notificationSoundSection.setAttribute('data-push-sound-device-uid-value', device.device_uid ?? '');

        // Show or hide sound preference based on push_enabled
        if (device.push_enabled) {
          notificationSoundSection.classList.remove('hidden');
        } else {
          notificationSoundSection.classList.add('hidden');
        }

        const silentRadio = notificationSoundSection.querySelector('input[name="notification_silent"][value="true"]');
        const soundRadio = notificationSoundSection.querySelector('input[name="notification_silent"][value="false"]');
        if (silentRadio && soundRadio) {
          silentRadio.checked = device.push_sound === false;
          soundRadio.checked = device.push_sound === true;
        }
      }

      container.setAttribute('data-push-toggle-device-uid-value', device.device_uid ?? '');
    } catch (error) {
      console.error('Failed to update push notification device info:', error);
    }
  }

  static downloadMobileNews() {
    const el = document.getElementById('downloadMobileNews');
    if (!el) return;

    el.click();
  }
}

window.TurboNativeBridge = Bridge
export default Bridge
